module.exports = __webpack_public_path__ + "media/images/books-ebf8189f8883dd0030cf440b68b38efc96957f6ff46ef33aaad8e44511f888ea.jpg";